import React from 'react'
import Purchase from "./Purchase";
import PurchaseCreate from "./create/PurchaseCreate";
import PurchaseEdit from "./PurchaseEdit";
import PurchaseComplete from "./complete/PurchaseComplete";
import PurchaseDetail from "./detail/PurchaseDetail";
import {Router} from "@reach/router";
import {PurchaseContextProvider} from "../../context/PurchaseContext";


const PurchaseContainer = () => {

    return (
        <React.Fragment>
            <PurchaseContextProvider>
                <Router>
                    <Purchase path={'/'}/>
                    <PurchaseCreate path={'/create'}/>
                    <PurchaseDetail path={'/detail/:purchaseId'} />
                    <PurchaseEdit path={'/edit/:purchaseId'} />
                    <PurchaseComplete path={'/complete/:purchaseId'} />
                </Router>
            </PurchaseContextProvider>
        </React.Fragment>
    )
}

export default PurchaseContainer